import type { components } from '@front/generated/apiClient';
import { DomainV2 } from 'troppus-common/domain';

import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;
import ImportTableDefinitionRevision = DomainV2.Import.ImportTableDefinitionRevision;

type ApiDefinition = components['schemas']['ImportTableDefinition'];
type ApiDetail = components['schemas']['ImportTableDefinition.Detail'];
type ApiRevision = components['schemas']['ImportTableDefinition.Revision'];
type SchemaColumnProps = ImportTableDefinition.SchemaJson.Column.Props;

export const definitionFromApi = (api: ApiDefinition): ImportTableDefinition => {
  return ImportTableDefinition.Construct({
    id: api.id,
    projectId: api.projectId,
    sourceSystemId: api.sourceSystemId,
    displayName: api.displayName,
    description: api.description,
    isActive: api.isActive,
    activeRevisionId: api.activeRevisionId ?? undefined,
    lastRevisionId: api.lastRevisionId,
    createdAt: api.createdAt,
    createdBy: api.createdBy,
    updatedAt: api.updatedAt,
    updatedBy: api.updatedBy,
  });
};

export const revisionFromApi = (api: ApiRevision): ImportTableDefinitionRevision => {
  return ImportTableDefinitionRevision.Construct({
    id: api.id,
    projectId: api.projectId,
    importTableDefinitionId: api.importTableDefinitionId,
    revisionNumber: api.revisionNumber,
    schemaJson: {
      hasHeaderRow: api.schemaJson.hasHeaderRow,
      encoding: api.schemaJson.encoding,
      delimiter: api.schemaJson.delimiter,
      columns: api.schemaJson.columns.map(
        (col): SchemaColumnProps => ({
          name: col.name,
          type: col.type,
          required: col.required,
          description: col.description ?? undefined,
          destination: col.destination,
          transformRules: col.transformRules,
          ...(col.multiValued ? { multiValued: true } : {}),
        }),
      ),
    },
    uniqueKeys: {
      customer: api.uniqueKeys.customer,
      contract: api.uniqueKeys.contract,
    },
    loadMode: api.loadMode,
    importMethod: api.importMethod,
    compatibilityType: api.compatibilityType,
    changeSummary: api.changeSummary,
    createdAt: api.createdAt,
    createdBy: api.createdBy,
  });
};

export const detailFromApi = (api: ApiDetail): ImportTableDefinition.Detail => ({
  definition: definitionFromApi(api.definition),
  activeRevision: api.activeRevision ? revisionFromApi(api.activeRevision) : undefined,
  lastRevision: revisionFromApi(api.lastRevision),
});
